module.exports = __webpack_public_path__ + "static/img/jigou-guangzhou-top.8d92964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-guangzhou-top.png
// module id = tnqd
// module chunks = 2